import BaseServices from "./BaseServices";

const PartnerServices = {
    GetPartnerDesignModels: async (model) => {
        return BaseServices.Post("/api/partner/get-partner-design-models", model);
    },
    GetPartnerDesignAsync: async (designId) => {
        return BaseServices.Get(`/api/partner/get-partner-design-async/${designId}`);
    },
    GetPushingPhotoshopFiles: async (model) => {
        return BaseServices.Post("/api/partner/get-pushing-photoshop-files", model);
    },
    CreateUpdatePartnerDesign: async (model) => {
        return BaseServices.Post("/api/partner/create-update-partner-design", model);
    },
    GetCusSetByPaging: async (model) => {
        return BaseServices.Post("/api/partner/get-cus-set-by-paging", model);
    },
    GetCusSetById: async (id) => {
        return BaseServices.Get(`/api/partner/get-cus-set-by-id/${id}`);
    },
    GetTemplateByPage: async (page) => {
        return BaseServices.Post(`/api/designTemplate/get-template-by-page-partner`, page);
    },
    CreateUpdateRangeSetGroup: async (models, setId) => {
        return BaseServices.Post("/api/partner/create-update-range-set-group/" + setId, models);
    },
    DeleteDesign: async (designId) => {
        return BaseServices.Get(`/api/partner/delete-design/${designId}`);
    },
    CreateUpdateCusSet: async (model) => {
        return BaseServices.Post("/api/partner/create-update-cus-set", model);
    },
    DisableImage: async (imageId, isDisabled) => {
        return BaseServices.Get(`/api/partner/disable-image/${imageId}/${isDisabled}`);
    },
    RemoveImage: async (imageId) => {
        return BaseServices.Get(`/api/partner/remove-image/${imageId}`);
    },
    GetGroupPartnerCostDiscounts: async () => {
        return BaseServices.Get("/api/partner/get-group-partner-cost-discounts");
    },
    CreateUpdatePartnerCostDiscountSelected: async (lst) => {
        return BaseServices.Post("/api/partner/create-update-partner-cost-discount-selected", lst);
    },
    GetFlexibleFixedDiscountModel: async () => {
        return BaseServices.Get("/api/partner/get-flexible-fixed-discount-model");
    },
};

export default PartnerServices;
